import { z } from 'zod/v4';

/** The order numbers to check — at least one, none empty. */
export const CheckOrderNumbersBodySchema = z.array(z.string().min(1)).min(1);

export type CheckOrderNumbersBody = z.infer<typeof CheckOrderNumbersBodySchema>;

/** The numbers already taken by the caller's live orders (purchase or sales, per route), each once, in the order asked. */
export const TakenOrderNumbersSchema = z.array(z.string());

/** Wire shape: the standard `reply.apiSuccess` envelope around the list. */
export const CheckOrderNumbersResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: TakenOrderNumbersSchema,
});

export type CheckOrderNumbersResponse = z.infer<
  typeof CheckOrderNumbersResponseSchema
>;
